<template>
    <div class="py-12">
        <h1
            class="text-2xl font-medium leading-normal tracking-small text-gray-800"
        >
            Edit
        </h1>

        <inertia-link :href="route('kiosk.premade-templates.keywords.index')">
            <AtomicButton class="mt-2" color="yellow" size="sm">
                Back
                <template #icon>
                    <BackspaceIcon
                        class="mr-2 h-6 w-6 transition duration-200 group-hover:text-gray-600"
                    />
                </template>
            </AtomicButton>
        </inertia-link>

        <form class="flex flex-col" @submit.prevent="updateKeyword">
            <TextInput
                v-model="v$.form.keyword.$model"
                class="mt-5 w-52 sm:w-80"
                label="Keyword"
                type="text"
                placeholder="max 255 characters"
                :error="getError('keyword')"
                required
            />

            <div class="mt-6 flex flex-row">
                <AtomicButton
                    type="submit"
                    color="yellow"
                    size="sm"
                    :disabled="loading || v$.$invalid"
                >
                    Save changes
                </AtomicButton>
            </div>
        </form>
    </div>
</template>

<script lang="ts" setup>
import AtomicButton from '@atomic/Buttons/AtomicButton.vue';
import TextInput from '@atomic/Inputs/TextInput.vue';
import { route } from 'ziggy-js';
import IKeyword from '@/types/Templates/IKeyword';
import { create } from '@/composables/useNotifications';
import { BackspaceIcon } from '@heroicons/vue/24/outline';
import { router } from '@inertiajs/vue3';
import { reactive, ref } from 'vue';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import IInputErrors from '@/types/Atomic/IInputErrors';

const props = defineProps<{
    keyword: IKeyword;
}>();

const state = reactive({
    form: {
        keyword: props.keyword.keyword,
    },
});

const rules = {
    form: {
        keyword: { required },
    },
};

const v$ = useVuelidate(rules, state);
const errors = ref<IInputErrors>({});
const loading = ref(false);

const updateKeyword = () => {
    v$.value.form.keyword.$touch();
    if (v$.value.form.keyword.$error) {
        return;
    } else {
        loading.value = true;
        router.put(
            route('kiosk.premade-templates.keywords.update', {
                premadeTemplateKeyword: props.keyword.id,
            }),
            state.form,
            {
                onSuccess: () => {
                    create({
                        title: 'Keyword updated',
                        type: 'success',
                    });
                    errors.value = {};
                    v$.value.$reset();
                },
                onError: (err) => {
                    errors.value = err;
                    create({
                        title: 'Keyword not updated',
                        type: 'error',
                    });
                },
                onFinish: () => {
                    loading.value = false;
                },
            }
        );
    }
};

const getError = (field: string) => {
    return (
        v$.value.form[field]?.$errors[0]?.$message ||
        errors.value?.[field] ||
        ''
    );
};
</script>

<style></style>
